module.exports = __webpack_public_path__ + "img/vip-banner-bg.b6e651e5.png";